export const AGGREGATION_SCALES = [1, 5, 10, 50, 100, 250, 500, 1000];
export const DEFAULT_AGGREGATION_SCALE  = AGGREGATION_SCALES[0];
